import { render, staticRenderFns } from "./FollowStatusTabs.vue?vue&type=template&id=4ef77afd&scoped=true&"
import script from "./FollowStatusTabs.vue?vue&type=script&lang=js&"
export * from "./FollowStatusTabs.vue?vue&type=script&lang=js&"
import style0 from "./FollowStatusTabs.vue?vue&type=style&index=0&id=4ef77afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef77afd",
  null
  
)

export default component.exports